"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "style__Container",
  componentId: "sc-1uovv7p-0"
})(["display:flex;position:absolute;top:-21px;width:100%;"]);

exports.Container = Container;

var Box = _styledComponents["default"].div.withConfig({
  displayName: "style__Box",
  componentId: "sc-1uovv7p-1"
})(["display:flex;justify-content:center;"]);

exports.Box = Box;